import React, { useState, useEffect } from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import AuthService from '../../services/api/auth';
import CodiceFiscale from 'codice-fiscale-js';
import { FormField, FormSelect, FormRadio, FormDate } from './Fields';

const translate = trKey => window.VULOG_TRANSLATE(trKey);

let FiscalCodeForm = ({ handleSubmit, provinceOptions, fiscalCodeValues, populateForm, ...props }) => {
    const defaultCityOptions = [{ value: '', label: '' }];
    const [cityOptions, setCityOptions] = useState(defaultCityOptions);
    const [selectedProvince, setSelectedProvince] = useState(provinceOptions[0].value || { value: '', label: '' });
    const [isGenerateDisabled, setIsGenerateDisabled] = useState(true);

    useEffect(() => {
        setIsGenerateDisabled(true);
        if (!fiscalCodeValues) return;
        const { name, surname, birthDate, gender, birthPlace, birthPlaceProvince } = fiscalCodeValues;
        if (!name || !surname || !birthDate || !gender || !birthPlace || !birthPlaceProvince) {
            return;
        }
        // Check if the date is a valid date
        const isValidDate = d => !isNaN(d);
        const validBirthDate = isValidDate(new Date(birthDate));
        if (!validBirthDate) return;

        setIsGenerateDisabled(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fiscalCodeValues]);

    useEffect(() => {
        if (selectedProvince && selectedProvince.value !== '') {
            const fetchCityOptions = async () => {
                let cities = [];
                try {
                    setCityOptions(defaultCityOptions);
                    cities = await AuthService.getFiscalCodeCities(selectedProvince);
                    cities = [defaultCityOptions, ...cities];
                    cities && setCityOptions(cities); // update cities list options
                    props.change('birthPlace', ''); // select empty option
                } catch (error) {
                    console.error({ error });
                }
            };
            fetchCityOptions();
        } else {
            setCityOptions(defaultCityOptions);
            props.change('birthPlaceProvince', '');
            props.change('birthPlace', '');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedProvince]);

    const generateFiscalCode = () => {
        const fc = fiscalCodeValues;
        const birthDate = new Date(fc.birthDate);
        const fiscalCode = new CodiceFiscale({
            name: fc.name,
            surname: fc.surname,
            gender: fc.gender,
            day: birthDate.getDate(),
            month: birthDate.getMonth() + 1,
            year: birthDate.getFullYear(),
            birthplace: fc.birthPlace,
            birthplaceProvincia: fc.birthPlaceProvince,
        });
        props.change('fiscalCode', fiscalCode.code);
    };

    const genderOptions = [
        { label: translate('Male'), value: 'M' },
        { label: translate('Female'), value: 'F' },
    ];

    const isBirthPlaceDisabled = cityOptions?.length === 1 && cityOptions[0].value === '';

    const esteroValue = 'EE';
    const isBirthPlaceCountry =
        selectedProvince?.value === esteroValue ||
        (selectedProvince?.value === undefined && selectedProvince === esteroValue);

    return (
        <form onSubmit={handleSubmit}>
            <FormField id={'first-name'} name={'name'} disabled label={translate('First Name')} />
            <FormField id={'last-name'} name={'surname'} disabled label={translate('Last Name')} />
            <FormRadio id={'gender'} name={'gender'} label={translate('Gender')} options={genderOptions} />
            <FormDate label={translate('Birth Date')} />
            <FormSelect
                list={provinceOptions}
                id={'birthPlaceProvince'}
                label={`${translate('birth_place_province')}*`}
                name={'birthPlaceProvince'}
                onChange={e => {
                    setSelectedProvince(e.target.value);
                }}
            />
            <FormSelect
                list={cityOptions}
                id={'birthPlace'}
                label={isBirthPlaceCountry ? `${translate('birth_place_country')}*` : `${translate('birth_place')}*`}
                name={'birthPlace'}
                disabled={isBirthPlaceDisabled}
            />
            <div className="form-row mb-2">
                <div className="col-4 mb-0"></div>
                <div className="col">
                    <button
                        className="btn btn-secondary btn-block"
                        onClick={generateFiscalCode}
                        type={'button'}
                        disabled={isGenerateDisabled}
                    >
                        {translate('calculate_fiscal_code')}
                    </button>
                </div>
            </div>
            <FormField id={'fiscal-code'} name={'fiscalCode'} label={`${translate('fiscal_code')}*`} />
        </form>
    );
};

FiscalCodeForm = reduxForm({
    // a unique name for the form
    form: 'fiscal-code',
})(FiscalCodeForm);

FiscalCodeForm = connect(state => ({
    initialValues: state.register.fiscalCode,
}))(FiscalCodeForm);

export default FiscalCodeForm;
